import useFormatters from "./useFormatters";

const useCPResultData = (formik, sortDirection) => {
  const {
    requestDateFormatter,
    ItemNoFormatter,
    commonTextFormatter,
    materialCodeFormatter,
    emptyMiddleware,
    requestDateApplyAllHeaderFormatter,
    quantityFormatter,
    confirmDateFormatter
  } = useFormatters(formik, sortDirection);

  const columnsList: TableColumn[] = [
    {
      id: "itemNo",
      label: "Item No.",
      style: { minWidth: 24, padding: 8, fontSize: "14px" },
      formatter: ItemNoFormatter,
      align: "center"
    },
    {
      id: "materialCode",
      label: "Material Code",
      style: { minWidth: 152, padding: 8 },
      formatter: materialCodeFormatter,
      align: "left"
    },
    {
      id: "materialDescription",
      label: "Material Description",
      style: { minWidth: 300, padding: 8 },
      align: "left",
      formatter: commonTextFormatter
    },
    {
      id: "quantity",
      label: "จำนวน",
      style: { minWidth: 64, padding: 8 },
      align: "center",
      formatter: quantityFormatter
    },
    {
      id: "requestDate",
      label: "Request Date",
      style: { minWidth: 180, padding: 8 },
      align: "center",
      formatter: requestDateFormatter,
      headerFormatter: requestDateApplyAllHeaderFormatter
    },
    {
      id: "originalDate",
      label: "Orginal Date",
      align: "center",
      formatter: commonTextFormatter,
      style: { minWidth: 112, padding: 8 }
    },
    {
      id: "confirmDate",
      label: "Confirm Date",
      align: "center",
      formatter: confirmDateFormatter,
      style: { minWidth: 96, padding: 8, color: "#FF2600" }
    },
    {
      id: "plant",
      label: "Plant",
      formatter: commonTextFormatter,
      style: { minWidth: 64, padding: 8 },
      align: "center"
    }
  ];
  return {
    columnsList,
    emptyMiddleware
  };
};
export default useCPResultData;
